const product = [
  {
    path: "/product/user/group",
    component: resolve =>
      require(["@/product/view/user-group/user-group.vue"], resolve),
    name: "用户组",
    meta: {
      title: "用户组",
      affix: true
    }
  },
  {
    path: "/product/scenic",
    component: resolve =>
      require(["@/product/view/scenic/scenic.vue"], resolve),
    name: "景区管理",
    meta: {
      title: "景区管理",
      affix: true
    }
  },
  {
    path: "/product/message",
    component: resolve =>
      require(["@/product/view/message/message.vue"], resolve),
    name: "设置",
    meta: {
      title: "设置",
      affix: true
    }
  },
  {
    path: "/product/supplier",
    component: resolve =>
      require(["@/product/view/supplier/supplier.vue"], resolve),
    name: "供应商管理",
    meta: {
      title: "供应商管理",
      affix: true
    }
  },
  {
    path: "/product/category",
    component: resolve =>
      require(["@/product/view/category/category.vue"], resolve),
    name: "门票分类",
    meta: {
      title: "门票分类",
      affix: true
    }
  },
  {
    path: "/product/scenic/:id",
    component: resolve =>
      require(["@/product/view/scenic/scenic-info.vue"], resolve),
    name: "景区详情",
    meta: {
      title: "景区详情",
      affix: true
    }
  },
  {
    path: "/product/member",
    component: resolve =>
      require(["@/product/view/member/member.vue"], resolve),
    name: "会员管理",
    meta: {
      title: "会员管理",
      affix: true
    }
  },
  {
    path: "/product/member/info/:id",
    component: resolve =>
      require(["@/product/view/member/member-info.vue"], resolve),
    name: "会员详情",
    meta: {
      title: "会员详情",
      affix: true
    }
  },
  {
    path: "/product/member/audit",
    component: resolve =>
      require(["@/product/view/member/member-audit.vue"], resolve),
    name: "待审核会员",
    meta: {
      title: "待审核会员",
      affix: true
    }
  },
  {
    path: "/product/ticket/:id",
    component: resolve =>
      require(["@/product/view/ticket/ticket.vue"], resolve),
    name: "景区门票",
    meta: {
      title: "景区门票",
      affix: true
    }
  },
  {
    path: "/product/calendarInventory",
    component: resolve =>
      require([
        "@/product/view/calendar-inventory/calendar-inventory.vue"
      ], resolve),
    name: "日历库存",
    meta: {
      title: "日历库存",
      affix: true
    }
  },
  {
    path: "/product/addticket/:id",
    component: resolve => require(["@/product/view/ticket/add.vue"], resolve),
    name: "门票设置",
    meta: {
      title: "门票设置",
      affix: true
    }
  },
  {
    path: "/product/pricing/:id",
    component: resolve =>
      require(["@/product/view/ticket/pricing.vue"], resolve),
    name: "价格策略",
    meta: {
      title: "价格策略",
      affix: true
    }
  },
  {
    path: "/product/ticket/plan/:id",
    component: resolve => require(["@/product/view/plan/plan.vue"], resolve),
    name: "销售计划",
    meta: {
      title: "销售计划",
      affix: true
    }
  },
  {
    path: "/product/order/list",
    component: resolve => require(["@/product/view/order/order.vue"], resolve),
    name: "订单列表",
    meta: {
      title: "订单列表",
      affix: true
    }
  },
  {
    path: "/product/order/refund",
    component: resolve => require(["@/product/view/order/refund.vue"], resolve),
    name: "退单管理",
    meta: {
      title: "退单管理",
      affix: true
    }
  },
  {
    path: "/product/order/rebate",
    component: resolve => require(["@/product/view/order/rebate.vue"], resolve),
    name: "提现审核",
    meta: {
      title: "提现审核",
      affix: true
    }
  },
  {
    path: "/product/order/rebate/list",
    component: resolve =>
      require(["@/product/view/order/rebate-list.vue"], resolve),
    name: "补贴记录",
    meta: {
      title: "补贴记录",
      affix: true
    }
  }
];
export default product;
